export default __webpack_public_path__ + "static/media/LucasLejeune.42abf085.png";